module.exports = __webpack_public_path__ + "img/logo1.0c2579f8.png";